// theming
import mainTheme from "components/main/MainTheme";
import { ThemeProvider, responsiveFontSizes } from "@mui/material/styles";

// material design
import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";

// fonts and icons
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressBook as iconContacts } from "@fortawesome/pro-thin-svg-icons";

// entzy config and components
// import configEntzy from "components/config/ConfigEntzy";
import ContactsList from "./ContactsList";
import { HeaderMenuTag } from "components/utils/common/CommonTags";

function ContactsIndex(props) {
  return (
    <ThemeProvider theme={responsiveFontSizes(mainTheme)}>
      <Box className="box-default">
        <HeaderMenuTag icon={iconContacts} text="Contacts" />
        <ContactsList {...props} />
      </Box>
    </ThemeProvider>
  );
}

export default ContactsIndex;
